/**
 * Handles the English case, where there is no val, vs. the Spanish case
 * @param {string} key
 * @param {{[key: string]: string | null}} strings
 * @returns {string}
 */
export function getString(key, strings) {
  if (key in strings && strings[key] != null) {
    const val = /** @type {string} */ (strings[key]);
    return val;
  }
  return key;
}
